import React from 'react';
import { motion } from 'motion/react';

interface ToggleProps {
  active: boolean;
  onClick: (e?: React.MouseEvent) => void;
  color?: string;
  disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({ active, onClick, color = 'bg-cyan-600', disabled }) => (
  <button 
    onClick={(e) => !disabled && onClick(e)} 
    className={`w-11 h-6 rounded-full flex items-center p-1 transition-all duration-300 relative border ${active ? `${color} border-transparent` : 'bg-zinc-100/30 dark:bg-zinc-900/10 border-cyan-500/20 hover:border-cyan-500/40'} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-100'}`}
  >
    <div className={`absolute inset-0 rounded-full shadow-inner pointer-events-none transition-opacity ${active ? 'opacity-10' : 'opacity-0'}`} />
    <motion.div 
      initial={false}
      animate={{ 
        x: active ? 20 : 0,
        scale: 1
      }}
      transition={{ type: "spring", stiffness: 600, damping: 35 }}
      className="w-4 h-4 rounded-full shadow-md flex items-center justify-center bg-white z-10" 
    />
  </button>
);
